import { useCallback, useContext } from 'react';
import { PortalsContext } from '../../contextProviders/SplashScreenProviders/UserAndAccountProviders/PortalsProvider';
import portalTypeCheckers from '../../types/portalTypeCheckers';
import STORE from '../../store';
import AccountPickerContext from '../../contexts/AccountPickerContext';

const useAddToCurrentPortal = () => {
  const { selectedPortal } = useContext(PortalsContext);
  const { selectedAccountId } = useContext(AccountPickerContext);

  const addToCurrentExecutivePortal = useCallback(
    async (newDashboard: DashboardType): Promise<void> => {
      if (!selectedPortal) {
        return;
      }

      if (portalTypeCheckers.isAdminPortal(selectedPortal)) {
        return;
      }

      const newPortal: ExecutivePortal | EngagementPortal = {
        ...selectedPortal,
        dashboardIds: [...selectedPortal.dashboardIds, newDashboard.id],
      };

      if (portalTypeCheckers.isEngagementPortal(newPortal)) {
        return STORE.contentDistributions
          .getEngagementPortalsRef({ accountId: selectedAccountId })
          .doc(newPortal.id)
          .set(newPortal);
      } else {
        return STORE.contentDistributions
          .getExecutivePortalsRef({ accountId: selectedAccountId })
          .doc(newPortal.id)
          .set(newPortal);
      }
    },
    [selectedAccountId, selectedPortal],
  );

  return addToCurrentExecutivePortal;
};

export default useAddToCurrentPortal;
